import {Injectable} from '@angular/core';
import {GoogleApiService} from 'ng-gapi';
import { HttpClient } from '@angular/common/http';

import {environment} from '../../environments/environment';
import { Subject } from 'rxjs';

declare var google;
const API_URL = environment.apiUrl;

// Refactor porque esto está un desastre
@Injectable({
  providedIn: 'root'
})
export class GapiPickerService {
    private subject = new Subject<any>();

    targetID: number;
    tipo: string;

    ssData: any;

    oauthToken;

    private loadSubject = new Subject<any>();
    onLoad$ = this.loadSubject.asObservable();

    constructor(public gapiService: GoogleApiService,
                private http: HttpClient) {
        gapiService.onLoad().subscribe();
    }

    getGapi() {
        return gapi;
    }

    apiLoad(targetID, tipo) {
        this.targetID = targetID;
        this.tipo = tipo;

        if (!this.oauthToken) {
            gapi.load('auth', {'callback': this.onAuthApiLoad.bind(this)});
        } else {
            gapi.load('picker', {'callback': this.createPicker.bind(this)});
        }
        // this.initPicker();
    }

    onAuthApiLoad() {
        const self = this;
        gapi.auth.authorize({
            client_id: '748787902858-v7tp7lh1h650j9uknh2fpiqm8jilf8gm.apps.googleusercontent.com',
            scope: [
                'https://www.googleapis.com/auth/drive',
                'https://www.googleapis.com/auth/drive.readonly',
                'https://www.googleapis.com/auth/spreadsheets',
                'https://www.googleapis.com/auth/drive',
                'https://www.googleapis.com/auth/spreadsheets.readonly'
            ],
            immediate: false
        }, self.handleAuthResult.bind(this));
    }

    handleAuthResult(authResult: any) {
        if (authResult && !authResult.error) {
            this.oauthToken = authResult.access_token;
            gapi.load('picker', {'callback': this.createPicker.bind(this)});
        }
    }

    createPicker() {
        const self = this;
        if (this.oauthToken) {
            const view = new google.picker.DocsView(google.picker.ViewId.FOLDERS)
                .setSelectFolderEnabled(true);
            const picker = new google.picker.PickerBuilder()
            // .enableFeature(google.picker.Feature.NAV_HIDDEN)
                .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
                .enableFeature(google.picker.Feature.SUPPORT_TEAM_DRIVES)
                .addView(google.picker.ViewId.DOCS)
                .addView(new google.picker.DocsView(google.picker.ViewId.DOCS)
                    .setEnableTeamDrives(true))
                .addView(view)
                .setOAuthToken(this.oauthToken)
                .setDeveloperKey('AIzaSyCqJX67ZZh_zJO7kghTpziYBIW7l10F8RU')
                .setCallback(self.pickerCallback.bind(this))
                .build();
            picker.setVisible(true);
        }
    }

    pickerCallback(data) {
        const self = this,
            model = {
                'recursos': [],
                'targetID': 0,
                'tipo': 'string',
                'estado': true
            };

        if (data[google.picker.Response.ACTION] === google.picker.Action.PICKED) {
            const docs = data[google.picker.Response.DOCUMENTS];

            for (let doc of docs) {
                const currRecurso = {
                    nombre: doc.name,
                    resumen: doc.name,
                    url: doc.url,
                    iconUrl: doc.iconUrl,
                    keyRecurso: doc.id,
                    isVisibleToStudent: false
                };
                model.recursos.push(currRecurso);
            }
            model.targetID = this.targetID;
            model.tipo = this.tipo;

            self.procesarDoc(model);
        }
    }

    procesarDoc(model) {
        const req = this.http.post(`${API_URL}/api/recursos/crear`, model);
        req.subscribe(res => {
            this.subject.next({
                tipo: 'agregarRecursos',
                targetTipo: this.tipo,
                targetID: this.targetID,
                elementos: res
            });
        });
    }

    getPickerServiceObservable() {
        return this.subject.asObservable();
    }

    createClassRoomButton(idContenedor, url) {
        gapi['sharetoclassroom'].render(idContenedor, {url: url});
    }

    createAdvancedClassRoomButton(idContenedor, data) {
        gapi['sharetoclassroom'].render(idContenedor, data);
    }

    initSpreadsheet(data) {
        this.ssData = data;
        if (!this.oauthToken) {
            gapi.load('auth', {'callback': this.onAuthApiLoadSS.bind(this)});
        } else {
            gapi.load('client', {'callback': this.loadClient.bind(this)});
        }
    }

    loadGapi() {
        if (!this.oauthToken) {
            gapi.load('auth', {'callback': this.onGapiAuthApiLoadSS.bind(this)});
        } else {
            gapi.load('client', {'callback': this.loadGapiClient.bind(this)});
        }
    }

    onAuthApiLoadSS() {
        const self = this;
        gapi.auth.authorize({
            client_id: '748787902858-v7tp7lh1h650j9uknh2fpiqm8jilf8gm.apps.googleusercontent.com',
            scope: [
                'https://www.googleapis.com/auth/drive',
                'https://www.googleapis.com/auth/drive.readonly',
                'https://www.googleapis.com/auth/spreadsheets',
                'https://www.googleapis.com/auth/drive',
                'https://www.googleapis.com/auth/spreadsheets.readonly'
            ],
            immediate: false
        }, self.handleAuthResultSS.bind(this));
    }

    onGapiAuthApiLoadSS() {
        const self = this;
        gapi.auth.authorize({
            client_id: '748787902858-v7tp7lh1h650j9uknh2fpiqm8jilf8gm.apps.googleusercontent.com',
            scope: [
                'https://www.googleapis.com/auth/drive',
                'https://www.googleapis.com/auth/drive.readonly',
                'https://www.googleapis.com/auth/spreadsheets',
                'https://www.googleapis.com/auth/drive',
                'https://www.googleapis.com/auth/spreadsheets.readonly'
            ],
            immediate: false
        }, self.handleGapiAuthResultSS.bind(this));
    }


    handleAuthResultSS(authResult: any) {
        if (authResult && !authResult.error) {
            this.oauthToken = authResult.access_token;
            gapi.load('picker', {'callback': this.gapiLoadClient.bind(this)});
        }
    }

    handleGapiAuthResultSS(authResult: any) {
        if (authResult && !authResult.error) {
            this.oauthToken = authResult.access_token;
            gapi.load('picker', {'callback': this.gapiLoadClientMain.bind(this)});
        }
    }

    gapiLoadClient() {
        gapi.load('client', {'callback': this.loadClient.bind(this)});
    }

    gapiLoadClientMain() {
        gapi.load('client', {'callback': this.loadGapiClient.bind(this)});
    }

    loadClient() {
        gapi.client.init({
            'clientId': '748787902858-v7tp7lh1h650j9uknh2fpiqm8jilf8gm.apps.googleusercontent.com',
            scope: 'https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/spreadsheets https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/spreadsheets.readonly',
            discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/classroom/v1/rest', 'https://sheets.googleapis.com/$discovery/rest?version=v4'],
            apiKey: 'AIzaSyCqJX67ZZh_zJO7kghTpziYBIW7l10F8RU'
        }).then(() => {
            this.crearSpreadsheet();
        });
    }

    loadGapiClient() {
        gapi.client.init({
            'clientId': '748787902858-v7tp7lh1h650j9uknh2fpiqm8jilf8gm.apps.googleusercontent.com',
            scope: 'https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/spreadsheets https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/spreadsheets.readonly',
            discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/classroom/v1/rest', 'https://sheets.googleapis.com/$discovery/rest?version=v4'],
            apiKey: 'AIzaSyCqJX67ZZh_zJO7kghTpziYBIW7l10F8RU'
        }).then(() => {
            this.loadSubject.next('');
        });
    }

    // Retorna el spreadsheet vacio
    retornarSpreadsheet(title, sheets: string[]) {
        gapi.client.init({
            'clientId': '748787902858-v7tp7lh1h650j9uknh2fpiqm8jilf8gm.apps.googleusercontent.com',
            scope: 'https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/spreadsheets https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/spreadsheets.readonly',
            discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/classroom/v1/rest', 'https://sheets.googleapis.com/$discovery/rest?version=v4'],
            apiKey: 'AIzaSyCqJX67ZZh_zJO7kghTpziYBIW7l10F8RU'
        });
        return gapi.client['sheets'].spreadsheets.create({
            'properties': {
                'title': title
            },
        });
    }

    appendValue(id, range, value) {
        return gapi.client['sheets'].spreadsheets.values.append({
            spreadsheetId: id,
            range: range,
            valueInputOption: 'USER_ENTERED',
          }, value);
    }

    crearSpreadsheet() {
        const data = this.ssData;
        const sheet = this.crearSheet(data, data.tipo);
        gapi.client['sheets'].spreadsheets.create({
            'properties': {
                'title': data.titulo
            },
            'sheets': [
                sheet
            ]
        }).then(response => {
            const that = this;
            gapi.client.load('drive', 'v2', () => {
                const request = gapi.client['drive'].permissions.insert({
                    'fileId': response.result.spreadsheetId,
                    'resource': {
                        'type': 'anyone',
                        'role': 'reader',
                        'withLink': true,
                    }
                });
                request.execute((executed) => {
                    setTimeout(function () {
                        that.subject.next({tipo: 'cargar-boton-classroom', url: response.result.spreadsheetUrl});
                    }, 250);
                });
            });
        });
    }

    crearSheet(datos, tipo) {
        const rowVals = this.obtenerFilas(datos, tipo),
            sheet = {
                'data': rowVals
            };
        return sheet;
    }

    obtenerFilas(datos, tipo) {
        if (tipo === 'unidad') {
            let data = [{
                    'startRow': 0,
                    'rowData': [{
                        'values': [
                            {
                                'userEnteredValue': {'stringValue': 'Unidad: ' + datos.nombre},
                                'userEnteredFormat': {'textFormat': {'bold': true, 'fontSize': 17}}
                            }
                        ]
                    }]
                }, {
                    'startRow': 1,
                    'rowData': [{
                        'values': [
                            {
                                'userEnteredValue': {'stringValue': 'Meta'},
                                'userEnteredFormat': {'wrapStrategy': 'WRAP', 'textFormat': {'bold': true, 'fontSize': 12}}
                            },
                            {
                                'userEnteredValue': {'stringValue': 'Criterio'},
                                'userEnteredFormat': {'wrapStrategy': 'WRAP', 'textFormat': {'bold': true, 'fontSize': 12}}
                            },
                            {
                                'userEnteredValue': {'stringValue': 'Foundational'},
                                // 'userEnteredValue': {'stringValue': 'Logro destacado'},
                                'userEnteredFormat': {'wrapStrategy': 'WRAP', 'textFormat': {'bold': true, 'fontSize': 12}}
                            },
                            {
                                'userEnteredValue': {'stringValue': 'Mastery'},
                                'userEnteredFormat': {'wrapStrategy': 'WRAP', 'textFormat': {'bold': true, 'fontSize': 12}}
                            },

                            // {
                            //     'userEnteredValue': {'stringValue': 'Logro parcial'},
                            //     'userEnteredFormat': {'wrapStrategy': 'WRAP', 'textFormat': {'bold': true, 'fontSize': 12}}
                            // },
                            // {
                            //     'userEnteredValue': {'stringValue': 'No logro'},
                            //     'userEnteredFormat': {'wrapStrategy': 'WRAP', 'textFormat': {'bold': true, 'fontSize': 12}}
                            // },

                            {
                                'userEnteredValue': {'stringValue': 'Evidencia'},
                                'userEnteredFormat': {'wrapStrategy': 'WRAP', 'textFormat': {'bold': true, 'fontSize': 12}}
                            },
                        ]
                    }]
                }],
                numeroFila = 2;

            datos.datos.map(fila => {
                // const descMeta = fila.txtES != null ? fila.txtES : fila.txtEN != null ? fila.txtEN : fila.txtFR;
                const descMeta = fila.txtIdioma;
                let eventos: any = '';
                fila.eventosAprendizaje.map(ev => {
                    eventos += `${ev.nombre} \n`;
                });
                data.push({
                    'startRow': numeroFila,
                    'rowData': [{
                        'values': [
                            {
                                'userEnteredValue': {'stringValue': `${descMeta} (${fila.id})`},
                                'userEnteredFormat': {
                                    'wrapStrategy': 'WRAP',
                                    'textFormat': {'bold': false, 'fontSize': 12}
                                }
                            },
                            {
                                'userEnteredValue': {'stringValue': `${fila.criterioNivel}`},
                                'userEnteredFormat': {
                                    'wrapStrategy': 'WRAP',
                                    'textFormat': {'bold': false, 'fontSize': 12}
                                }
                            },
                            {
                                'userEnteredValue': {'stringValue': `${fila.ft}`},
                                'userEnteredFormat': {
                                    'wrapStrategy': 'WRAP',
                                    'textFormat': {'bold': false, 'fontSize': 12}
                                }
                            },
                            {
                                'userEnteredValue': {'stringValue': `${fila.mt}`},
                                'userEnteredFormat': {
                                    'wrapStrategy': 'WRAP',
                                    'textFormat': {'bold': false, 'fontSize': 12}
                                }
                            },
                            // {
                            //     'userEnteredValue': {'stringValue': `${fila.ld}`},
                            //     'userEnteredFormat': {
                            //         'wrapStrategy': 'WRAP',
                            //         'textFormat': {'bold': false, 'fontSize': 12}
                            //     }
                            // },
                            // {
                            //     'userEnteredValue': {'stringValue': `${fila.l}`},
                            //     'userEnteredFormat': {
                            //         'wrapStrategy': 'WRAP',
                            //         'textFormat': {'bold': false, 'fontSize': 12}
                            //     }
                            // },
                            // {
                            //     'userEnteredValue': {'stringValue': `${fila.lp}`},
                            //     'userEnteredFormat': {
                            //         'wrapStrategy': 'WRAP',
                            //         'textFormat': {'bold': false, 'fontSize': 12}
                            //     }
                            // },
                            // {
                            //     'userEnteredValue': {'stringValue': `${fila.nl}`},
                            //     'userEnteredFormat': {
                            //         'wrapStrategy': 'WRAP',
                            //         'textFormat': {'bold': false, 'fontSize': 12}
                            //     }
                            // },
                            {
                                'userEnteredValue': {'stringValue': `${eventos}`},
                                'userEnteredFormat': {
                                    'wrapStrategy': 'WRAP',
                                    'textFormat': {'bold': false, 'fontSize': 12}
                                }
                            }
                        ]
                    }]
                });
                numeroFila++;
            });
            return data;
        }
    }
}
